// extracted by mini-css-extract-plugin
export default {"wrapper":"GameCard_wrapper__dZFjP"};